<template>
  <div class="counter">
    <div class="counter__score" :style="setStyle">{{ item.score }}</div>
    <div class="counter__body">
      <div class="counter__city">{{ item.city }}</div>
      <div class="counter__region">{{ item.region }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'SummaryCounter',

  props: {
    delay: {
      type: Number,
      required: false,
      default: 2000,
    },
  },

  data() {
    return {
      item: {
        score: 0,
        city: '',
        region: '',
        color: 'black',
      },
      count: 0,
      prevCount: null,
      useTimer: false,
      timeout: null,
      states: {
        '0,25000': 'small',
        '25000,50000': 'medium',
        '50000,100000': 'normal',
        '100000,20000000': 'large',
      },
    };
  },

  computed: {
    ...mapState({
      stopped: (state) => state.counter.stopped,
      clickedRegion: (state) => state.dataLayer.selected,
      selectedRegion: (state) => state.dataLayer.active,
      featureHover: (state) => state.dataLayer.hover,
      featureClicked: (state) => state.dataLayer.clicked,
      selectedYear: (state) => state.rawData.year,
    }),

    ...mapGetters({
      items: 'rawData/separatedData',
      statedFilters: 'filter/filters',
    }),

    state() {
      return this.states[this.statedFilters.Inwoners.value[0]];
    },

    list() {
      return this.items[this.state];
    },

    setStyle() {
      return `background-color: ${this.item.color}`;
    },
  },

  mounted() {
    if (this.useTimer) {
      this.timeout = setTimeout(this.loop, this.delay);
    }
  },

  watch: {
    stopped(isStopped) {
      if (isStopped) {
        this.$store.commit('counter/setActive', null);
        clearTimeout(this.timeout);
      } else {
        this.count = this.prevCount;
        if (this.useTimer) {
          this.useTimer = true;
        }
        this.prevCount = null;

        if (this.useTimer) {
          this.timeout = setTimeout(this.loop, 100);
        }
      }
    },

    statedFilters() {
      clearTimeout(this.timeout);
      this.count = 0;

      if (!this.stopped) {
        if (this.useTimer) {
          this.timeout = setTimeout(this.loop, 100);
        }
      }
    },

    selectedYear() {
      clearTimeout(this.timeout);
      this.count = 0;

      if (!this.stopped) {
        if (this.useTimer) {
          this.timeout = setTimeout(this.loop, 100);
        }
      }
    },

    selectedRegion(value) {
      if (value === null) {
        return;
      }

      if (this.featureHover) {
        if (this.useTimer) {
          clearTimeout(this.timeout);
          this.timeout = null;
        }

        if (this.prevCount === null) {
          this.prevCount = this.count;
        }

        const region = value.getProperty('statnaam');
        const index = this.list.findIndex((item) => item.Gemeente === region);

        this.count = index;
        this.useTimer = false;

        this.setSpecs();
      }
    },
  },

  methods: {
    loop() {
      if (this.count === this.list.length) {
        this.count = 0;
      }

      this.setSpecs();
    },

    setSpecs() {
      const listItem = this.list[this.count];

      if (listItem) {
        // this.$store.commit('counter/setActive', listItem);

        this.item.score = listItem.Ranking;
        this.item.city = listItem.Gemeente;
        this.item.region = listItem.Provincie;
        this.item.color = listItem.colors;
      }

      if (this.useTimer) {
        this.count += 1;
        this.timeout = setTimeout(this.loop, this.delay);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .counter {
    align-items: center;
    display: none;

    .gm-style & {
      display: flex;
    }

    &__score {
      @include font-size(epsilon, 24px);

      align-items: center;
      align-self: stretch;
      color: $color-white;
      display: flex;
      font-weight: bold;
      justify-content: center;
      min-height: 35px;
      min-width: 35px;
      padding-left: $global-spacing-unit-quarter;
      padding-right: $global-spacing-unit-quarter;
    }

    &__body {
      @include font-size(micro, 12px);

      min-width: 115px;
      padding: $global-spacing-unit-quarter;
    }

    &__city {
      color: $color-black;
      font-weight: 900;
    }

    &__region {
      color: $color-thunder;
      font-weight: 300;
    }
  }
</style>
